import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CommonService} from "../../../../shared/services/common.service";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../state/app.state";
import {ForgotPasswordRequest} from "../../../core/authentication.actions";
import * as Validation from "../../../../shared/constants/validation.constants";
import {forgotPasswordInfo} from "../../../core/authentication.selectors";
import {Subject, takeUntil} from "rxjs";
import {AuthenticationService} from "../../../core/authentication.service";

@Component({
  selector: 'app-forgot-password-right-panel',
  templateUrl: './forgot-password-right-panel.component.html',
  styleUrls: ['./forgot-password-right-panel.component.css']
})
export class ForgotPasswordRightPanelComponent implements OnInit, OnDestroy {
  private readonly onDestroy: Subject<any> = new Subject<any>();
  loading: boolean = false;
  buttonLabel: string = 'RESET PASSWORD';
  errorMessages: any = {};
  validation = Validation;
  errorMessageMap = {
    username: {
      required: 'This field is required.'
    }
  }

  forgotPasswordRequest = false;
  forgotPasswordSuccess = false;
  forgotPasswordFailure = false;
  timerValue = 30;

  form = new FormGroup({
    username: new FormControl({value: '', disabled: false}, {
      validators: [
        Validators.required,
      ]
    }),
  })

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private authenticationService: AuthenticationService
  ) {
  }

  ngOnInit() {
    this.authenticationService.forgotPasswordRequest
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.forgotPasswordRequest = true;
        this.forgotPasswordSuccess = false;
        this.forgotPasswordFailure = false;
        this.form.controls.username.disable({emitEvent: false});
      });

    this.authenticationService.forgotPasswordSuccess
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.forgotPasswordRequest = false;
        this.forgotPasswordSuccess = true;
        this.forgotPasswordFailure = false;
        this.buttonLabel = 'RESEND';
      });

    this.authenticationService.forgotPasswordFailure
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.forgotPasswordRequest = false;
        this.forgotPasswordSuccess = false;
        this.forgotPasswordFailure = true;
        this.form.controls.username.enable({emitEvent: false});
        this.buttonLabel = 'RESET PASSWORD';
      });

    this.form.controls.username.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        if (this.buttonLabel !== 'RESET PASSWORD') {
          this.buttonLabel = 'RESET PASSWORD';
        }
      })
  }

  forgot() {
    this.store.select(forgotPasswordInfo)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.loading = data?.loading;
      })
    if (this.form.invalid) {
      this.checkForErrors()
      return
    }
    const {username} = this.form.getRawValue();
    const payload = {
      username,
    };
    this.store.dispatch(ForgotPasswordRequest({payload}))
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  handleCounterComplete() {
    this.forgotPasswordSuccess = false;
    this.form.controls.username.enable({emitEvent: false});
  }


  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
